import { render } from "./ViewOriginalBlock.vue?vue&type=template&id=3ea98381&scoped=true"
import script from "./ViewOriginalBlock.vue?vue&type=script&lang=js"
export * from "./ViewOriginalBlock.vue?vue&type=script&lang=js"

import "./ViewOriginalBlock.vue?vue&type=style&index=0&id=3ea98381&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ea98381"]])

export default __exports__